import { useState, useCallback } from 'react';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../../global/Button';
import ShippingProviderLocations from '../../SelectShippingProviderView/ShippingProviderLocations';
import Dialog from '../../../../../global/Mui/Dialog';
import { getNextButtonStyles, getOptionButtonStyles } from '../../../../../utils/tbbRegistration';
import { getTrackerId, POSTHOG_CAPTURE_ATTRIBUTES, TRACKER_IDS } from '../../../../../config/tracker';
import qrUpsIcon from '../../../../../images/qr-code-ups-icon.svg';
import PrintBatteryLabelButton from '../../../Components/PrintBatteryLabelButton';

import './ReadyToShip.scss';

const {
  tbb: {
    lastStep: {
      findLocation: trackerFindLocation,
    },
  },
} = TRACKER_IDS;

export default function ReadyToShip({
  shippingMethod,
  address,
  onClick,
  stepTrackerProps,
  storeConfig,
  isVirtualBox = false,
}) {
  const { shippingProviderId } = shippingMethod ?? {};
  const {
    shippingAndRewardTitle,
    description,
    icon,
    ctaLabel,
    ctaLabel2,
    findLocation,
    locations,
  } = shippingMethod?.configuration ?? {};
  const [showLocations, setShowLocations] = useState(false);

  const handleLocationsClick = useCallback(() => {
    if (locations?.enabled) {
      setShowLocations(true);
    }

    if (findLocation) {
      window.open(findLocation, '_blank');
    }
  }, [locations, findLocation]);

  return (
    <div className="ReadyToShip">
      {!isVirtualBox && (
        <>
          <h1 className="ReadyToShip__title">{shippingAndRewardTitle}</h1>
          <p className="ReadyToShip__description">{description}</p>
        </>
      )}
      <Button
        type={BUTTON_TYPE.QUINARY}
        size={BUTTON_SIZE.LARGE}
        className="ReadyToShip__cta"
        onClick={onClick}
        trackerProps={stepTrackerProps}
        style={getNextButtonStyles(storeConfig)}
      >
        <img src={isVirtualBox ? qrUpsIcon : icon} alt="ups" className="ReadyToShip__carrier-icon" />
        {ctaLabel}
      </Button>
      {isVirtualBox && (
        <PrintBatteryLabelButton storeConfig={storeConfig} />
      )}
      {(findLocation || locations?.enabled) && (
        <Button
          type={BUTTON_TYPE.LINK}
          size={BUTTON_SIZE.SMALL}
          onClick={handleLocationsClick}
          className="ReadyToShip__secondary-cta"
          trackerProps={{
            [POSTHOG_CAPTURE_ATTRIBUTES.TRACKER_ID]: getTrackerId(trackerFindLocation),
          }}
          style={getOptionButtonStyles(storeConfig)}
        >
          {ctaLabel2}
        </Button>
      )}
      <Dialog open={showLocations} onClose={() => setShowLocations(false)}>
        <ShippingProviderLocations
          locations={locations}
          address={address}
          logo={icon}
          inDialog
          provider={shippingProviderId}
        />
      </Dialog>
    </div>
  );
}
